<template lang="html">

  <section class="footer--container">

    <a href="#" v-scroll-to="'.menu'" class="subir"></a>

    <footer>

      <div class="container flex wrap justify-between align-center">

         <a class="show-redes" @click="toggleRedes">{{$t('footer.siguenos')}}</a>

        <nav class="f-menu">
         
          <ul class="flex wrap justify-center">
            <li><router-link :to="$t('enlaces.contacto')">{{$t('enlaces.textos.contacto')}}</router-link></li>
            <li><router-link target="_blank" :to="$t('enlaces.mapa_web')">{{$t('enlaces.textos.mapa_web')}}</router-link></li>
            <li><router-link target="_blank" :to="$t('enlaces.politica_privacidad')">{{$t('enlaces.textos.politica_privacidad')}}</router-link></li>
            <li><router-link target="_blank" :to="$t('enlaces.datos_seguros')">{{$t('enlaces.textos.datos_seguros')}}</router-link></li>
            <li><router-link target="_blank" :to="$t('enlaces.politica_cookies')">{{$t('enlaces.textos.politica_cookies')}}</router-link></li>
            <li><router-link target="_blank" :to="$t('enlaces.aviso_legal')">{{$t('enlaces.textos.aviso_legal')}}</router-link></li>
            
          </ul>

        </nav>

        <idioma></idioma>

      </div>
      
      <rrss-slide @toggle="toggleRedes" :show="show_redes"></rrss-slide>

    </footer>


  </section>

</template>

<script lang="js">

  import RRSS_slide from '@/components/view-parts/footer-parts/rrss-slide'
  import Idioma from '@/components/view-parts/footer-parts/idioma'

  export default  {
    name: 'app-footer',
    props: [],
    mounted() {

      $(window).scroll(function(event) {

        var distancia = $(window).scrollTop();

        if(distancia <= 1000){
          $(".subir").removeClass('fadeInUp');

          if($(".subir").hasClass('animated')){
            $(".subir").addClass('animated fadeOutDown');
          }
          
        }else{
          $(".subir").removeClass('animated fadeOutDown');
          $(".subir").addClass('animated fadeInUp');

        }


      });
    },
    data() {
      return {
        show_redes : false
      }
    },
    methods: {
      toggleRedes : function (){
        this.show_redes = !this.show_redes;
      }
    },
    components :{
      'rrss-slide' : RRSS_slide,
      'idioma' : Idioma
    }
  }
</script>

<style scoped>
.container {
  max-width: 1200px;
}
.f-menu {
    width: 50%;
}
 @media screen and (max-width:800px){
  .container {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
 }
</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue